import React from 'react';
import './Legal.css';

const TermsOfService: React.FC = () => {
  const lastUpdated = 'November 10, 2024';

  return (
    <section className="legal-page">
      <h1>Terms of Service</h1>
      <p className="legal-meta">Last updated: {lastUpdated}</p>

      <div className="legal-highlight">
        By using AI Business Inside you agree to these terms. We publish editorial
        content about AI and business, and while we strive for accuracy, information
        is provided “as is” without warranties.
      </div>

      <div className="legal-section">
        <h2>Use of the Site</h2>
        <p>You may read, link to, and share our content for personal or professional purposes provided you credit AI Business Inside. Do not copy articles in full, run automated scraping at scale, or misuse the site in a way that disrupts service for others.</p>
      </div>

      <div className="legal-section">
        <h2>Content & Attribution</h2>
        <p>All articles, graphics, and branding elements are owned by AI Business Inside unless otherwise noted. When referencing or quoting our work, include a link back to the original article.</p>
      </div>

      <div className="legal-section">
        <h2>Disclaimer</h2>
        <p>News and research published here are informational and not financial, legal, or investment advice. Decisions based on our content are your responsibility.</p>
      </div>

      <div className="legal-section">
        <h2>User Submissions</h2>
        <p>If you send feedback, story tips, or other materials, you grant us permission to use that content to operate or improve the site. Do not submit confidential or proprietary information.</p>
      </div>

      <div className="legal-section">
        <h2>Third-Party Links & Ads</h2>
        <p>The site may reference external sources or future advertising partners. We are not responsible for their content or practices. Review their policies before engaging.</p>
      </div>

      <div className="legal-section">
        <h2>Termination & Changes</h2>
        <p>We may modify or discontinue the service at any time. These terms may also change; we will update the “Last updated” date and, when practical, provide additional notice.</p>
      </div>

      <div className="legal-section">
        <h2>Contact</h2>
        <p>Reach us at <a href="mailto:legal@aibusinessinside.com">legal@aibusinessinside.com</a> with any questions about these terms.</p>
      </div>
    </section>
  );
};

export default TermsOfService;
